<mat-toolbar class="ad6-toolbar">
  <button mat-icon-button (click)="onMenuButton()">
    <mat-icon>menu</mat-icon>
  </button>
  <span>{{ 'app.title' | translate }}</span>
  <span class="spacer"></span>

  <ad6-event-selector class="ad6-top-padding"></ad6-event-selector>
  <span class="spacer"></span>
  @if (environment(); as environment) {
    <span>{{ environment | translate }}</span>
  }
</mat-toolbar>

<mat-sidenav-container>
  <mat-sidenav #sidenav mode="side" opened="true" [class.open]="sidenavOpen()">
    <ad6-sidebar [sidenavOpen]="sidenavOpen()"></ad6-sidebar>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
